import { appointments as base } from './base';
import { appointments as CZ } from './CZ';
import { appointments as SK } from './SK';
import { appointments as RO } from './RO';
import { appointments as HU } from './HU';
import { appointments as HR } from './HR';

export const featureConfigMap = {
    base,
    CZ,
    RO,
    SK,
    HU,
    HR,
};
